import { useAuthContext } from '../auth/context';

export function usePermissions() {
  return useAuthContext().currentUser.permissions || [];
}
